import React from "react";
import BasicTable from "../BasicTable/BasicTable";

const ReviewTable = ({ allRestaurants }) => {
  return (
    <div style={{ backgroundColor: "white", padding: "10px 5px 20px" }}>
      <div className="restaurant-table-header">
        <p>Total Restaurants : {allRestaurants.length}</p>
      </div>
      <div style={{ padding: "5px 20px" }}>
        <BasicTable restaurants={allRestaurants} />
      </div>
    </div>
  );
};

export default ReviewTable;
